module.exports = __webpack_public_path__ + "static/img/user_story_avatar4.5dde87a4.png";